// Pass object-space position to the fragment shader.
// All pattern masks are computed from this — no UV needed.
varying vec3 v_objectPos;

void main() {
    v_objectPos = position;
}
